export enum Status {
  Pending,
  PendingRequestedInformation,
  Approved,
  Rejected,
  Withdrawn,
  Revoke,
  Suspended,
};
